import { Box, IconButton } from '@mui/material';

import { getAnalyzerType } from '../../utils/analyzerTypes/index';
import { Analyzer } from 'types';

interface Props {
  instrument: Analyzer;
  onClick: () => void;
  onDoubleClick: () => void;
  selected: boolean;
}

const InstrumentItem = ({
  instrument,
  onClick,
  onDoubleClick,
  selected,
}: Props) => {
  const getInstrumentImagePath = () => {
    let imageName = '';

    const analyzerType = getAnalyzerType(instrument.type);

    if (!instrument.enabled) {
      imageName = analyzerType.IMAGES.disconnected;
    } else if (instrument.status === false && instrument.enabled) {
      imageName = analyzerType.IMAGES.lostConnection;
    } else {
      imageName = analyzerType.IMAGES.connected;
    }

    return `analyzerImages/${imageName}`;
  };

  return (
    <Box component='div'>
      <IconButton
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          fontSize: '1rem',
          ...(selected && {
            backgroundColor: (theme) => theme.palette.action.hover,
          }),
        }}
        size='large'
      >
        <img src={getInstrumentImagePath()} alt='' />
        {instrument.name}
      </IconButton>
    </Box>
  );
};

export default InstrumentItem;
